import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import {} from "../models/ResponseModels/DetailsImageResponse";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ImagesLinkedToWo } from "../models/ResponseModels/DetailsResponse";
import ImagesTypeAccordionBox from "./ImagesTypeAccordionBox";
import HideImageIcon from "@mui/icons-material/HideImage";

interface Props {
  index: number;
  episodeName: string;
  typesArray: ImagesLinkedToWo;
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  uuid: string | null;
  setSelectedUuid: React.Dispatch<React.SetStateAction<string>>;
  expandedList: string[] | null;
  setExpandedList: React.Dispatch<React.SetStateAction<string[] | null>>;
}

export default function ImagesEpisodeAccordionBox(props: Props) {
  function handleAccordionChange(index) {
    // Funzione per cambiare lo stato dell'espansione di un singolo accordion
    props.setExpandedList((prevExpanded) => {
      if (prevExpanded.includes(index)) {
        return prevExpanded.filter((i) => i !== index); // Elimina l'index dalla lista
      } else {
        return [...prevExpanded, index]; // Aggiungi index dalla lista
      }
    });
  }

  return (
    <Accordion
      key={"accordionBox_episode_" + props.index}
      expanded={props.expandedList.includes(
        "accordionBox_episode_" + props.index
      )}
      onChange={() =>
        handleAccordionChange("accordionBox_episode_" + props.index)
      }
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <span className="font-skyBold text-lg ">{props.episodeName}</span>
      </AccordionSummary>
      <AccordionDetails>
        <div id="content-images" className="p-7">
          {props.typesArray && Object.keys(props.typesArray).length > 0 ? (
            Object.keys(props.typesArray).map((typeLabel, index) => (
              <ImagesTypeAccordionBox
                index={props.index + "_" + index}
                label={typeLabel}
                imagesArray={props.typesArray[typeLabel]}
                openModal={props.openModal}
                setOpenModal={props.setOpenModal}
                uuid={props.uuid}
                setSelectedUuid={props.setSelectedUuid}
                expandedList={props.expandedList}
                setExpandedList={props.setExpandedList}
                workOrderTitle={props.episodeName}
              ></ImagesTypeAccordionBox>
            ))
          ) : (
            <div className="font-skyRegular text-gray-500 text-center py-2">
              <HideImageIcon color="disabled" /> <p>No content available</p>
            </div>
          )}
        </div>
      </AccordionDetails>
    </Accordion>
  );
}
